<!-- 订单列表 -->
<template>
  <div id="kt_post" class="post flex-column-fluid">
    <!--    顶部标题-->

    <div
        class="container-fluid d-flex flex-stack flex-column-fluid"
        style="padding: 0 30px;margin-top: 10px;"
    >
      <form action="#" style="width: 100%">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card body-->
          <div class="card-body">
            <!--begin::Compact form-->
            <div class="d-flex align-items-center">
              <!--begin::Input group-->
              <div class="position-relative w-md-400px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                <!--end::Svg Icon-->
                <input
                    id="sTitle"
                    v-model="params.name"
                    class="form-control form-control-solid ps-10"
                    name="shopName"
                    placeholder="用户昵称"
                    type="text"
                    value=""
                />

              </div>
              <!--end::Input group-->

              <!--begin::Input group-->
              <div class="position-relative w-md-400px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                <!--end::Svg Icon-->
                <input
                    id="sTitle"
                    v-model="params.userId"
                    class="form-control form-control-solid ps-10"
                    name="shopName"
                    placeholder="用户编号"
                    type="text"
                    value=""
                />

              </div>
              <!--end::Input group-->

              <!--begin:Action-->
              <div class="d-flex align-items-center">
                <div class="btn btn-primary me-5 btn-sm" @click="getList">
                  查询
                </div>
                <div class="btn btn-secondary me-5 btn-sm" @click="resetBtn">
                  重置
                </div>
                <a
                    id="kt_horizontal_search_advanced_link"
                    class="btn btn-link"
                    data-bs-toggle="collapse"
                    href="#kt_advanced_search_form"
                >高级查询</a
                >

              </div>

            </div>

            <!--begin::高级搜索-->
            <div id="kt_advanced_search_form" class="collapse">
              <!--begin::Separator-->
              <div class="separator separator-dashed mt-9 mb-6"></div>
              <!--end::Separator-->
              <!--begin::Row-->
              <div class="row g-8 mb-8">
                <!--begin::Col-->
                <!--                <div class="col-lg-3">
                                  <label class="fs-6 form-label fw-bolder text-dark"
                                  >父级编号</label
                                  >
                                  <br/>
                                  <el-input
                                      v-model="params.pUserId"
                                      clearable
                                      placeholder="请输入要查询的父级编号"
                                  >
                                  </el-input>
                                </div>-->
                <!--end::Col-->
                <!--begin::Col-->
                <div class="col-lg-3">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >手机号</label
                  >
                  <br/>
                  <el-input
                      v-model="params.tel"
                      clearable
                      placeholder="请输入要查询的手机号"
                  >
                  </el-input>
                </div>
                <!--end::Col-->
                <!--begin::Col-->
                <div class="col-lg-2">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >会员等级</label
                  >
                  <br/>
                  <el-select v-model="params.level"
                             placeholder="请选择会员等级"
                             style="margin-right: 20px;margin-left: 10px">
                    <el-option
                        label="小程序用户"
                        value="1">
                    </el-option>
                    <el-option
                        label="健康体验官"
                        value="2">
                    </el-option>
                    <el-option
                        label="健康星推官"
                        value="3">
                    </el-option>
                  </el-select>
                </div>
                <!--end::Col-->
                <!--begin::Col-->
                <div class="col-lg-2">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >代理等级</label
                  >
                  <br/>
                  <el-select v-model="params.agent"
                             placeholder="请选择代理等级"
                             style="margin-right: 20px;margin-left: 10px">
                    <el-option
                        label="省代"
                        value="1">
                    </el-option>
                    <el-option
                        label="市代"
                        value="2">
                    </el-option>
                    <el-option
                        label="区代"
                        value="3">
                    </el-option>
                  </el-select>
                </div>
                <!--end::Col-->
              </div>
              <!--end::Row-->
            </div>
            <!--end::Advance form-->

          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
      </form>
    </div>
    <div style="display: flex">
      <div
          id="kt_content_container"
          class="container"
          style="
        margin-top: 10px;
        max-width: 35%;
        flex-direction: row !important;
        display: flex;
      "
      >
        <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
          <div class="d-flex flex-column flex-column-fluid">
            <div id="kt_app_content" class="" style="margin-bottom: 10px">
              <!-- {{idArr}} {{ sumMoney }} -->
              <div class="card card-flush" style="position: relative">
                <div class="card-body">
                  <div id="myTabContent" class="tab-content">
                    <div
                        v-loading="loading"
                        class="card mb-5 mb-xl-8"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        element-loading-spinner="el-icon-loading"
                        element-loading-text="拼命加载中"
                        style="margin-left: 3px; width: 100%"
                    >
                      <div class="card-body py-3">
                        <div class="table-responsive">
                          <table
                              id="kt_ecommerce_products_table"
                              class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer"
                          >
                            <thead>
                            <tr
                                class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0"
                            >
                              <th
                                  aria-label="order_batch"
                                  class="text-center min-w-20px"
                                  colspan="1"
                                  rowspan="1"
                                  style="width: 30px"
                                  tabindex="0"
                              >
                                编号
                              </th>
                              <th
                                  aria-label="product_name"
                                  class="text-center min-w-100px"
                                  colspan="1"
                                  rowspan="1"
                                  style="width: 106.344px"
                                  tabindex="0"
                              >
                                昵称
                              </th>
                              <th
                                  aria-label="market_price"
                                  class="text-center min-w-30px"
                                  colspan="1"
                                  rowspan="1"
                                  style="width: 106.344px"
                                  tabindex="0"
                              >
                                手机号
                              </th>
                              <th
                                  aria-label="order_time"
                                  class="text-center min-w-40px"
                                  colspan="1"
                                  rowspan="1"
                                  style="width: 106.344px"
                                  tabindex="0"
                              >
                                会员等级
                              </th>
                              <th
                                  aria-label="order_time"
                                  class="text-center min-w-40px"
                                  colspan="1"
                                  rowspan="1"
                                  style="width: 106.344px"
                                  tabindex="0"
                              >
                                代理等级
                              </th>
                              <th
                                  aria-label="order_time"
                                  class="text-center min-w-20px"
                                  colspan="1"
                                  rowspan="1"
                                  style="width: 150px"
                                  tabindex="0"
                              >
                                操作
                              </th>
                            </tr>
                            </thead>
                            <tbody class="fw-semibold text-gray-600">
                            <tr
                                v-for="(item, index) in list"
                                :key="index"
                                :class="{ old: index % 2 == 0, even: index % 2 != 0 }"
                            >

                              <td class="text-center pe-0">
                              <span :title="item.id"
                                    class=""
                                    style="overflow: hidden;
                                  display: -webkit-box;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 3;
                                  line-height: 1.2;">{{ item.id }}</span>
                              </td>
                              <!-- 商品名称 -->
                              <td class="text-center pe-0">
                              <span :title="item.name"
                                    class=""
                                    style="overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    line-height: 1.2;">{{ item.name }}</span>
                              </td>
                              <!-- 市场价 -->
                              <td class="text-center pe-0">
                                <span>{{ item.tel }}</span>
                              </td>

                              <!-- 会员等级 -->
                              <td class="text-center pe-0">
                                <el-tag
                                    v-if="item.level==1"
                                    effect="info">
                                  小程序用户
                                </el-tag>
                                <el-tag
                                    v-if="item.level==2"
                                    effect="dark"
                                    type="warning">
                                  健康体验官
                                </el-tag>
                                <el-tag
                                    v-if="item.level==3"
                                    effect="dark"
                                    type="success">
                                  健康星推官
                                </el-tag>
                              </td>

                              <!-- 代理等级 -->
                              <td class="text-center pe-0">
                                <el-tag
                                    v-if="item.agent==1"
                                    effect="danger">
                                  省代
                                </el-tag>
                                <el-tag
                                    v-if="item.agent==2"
                                    effect="success">
                                  市代
                                </el-tag>
                                <el-tag
                                    v-if="item.agent==3"
                                    effect="warning">
                                  区代
                                </el-tag>
                              </td>

                              <td class="text-center">
                                <div class="btn btn-primary me-5 btn-sm" @click="gotoStatistics(item)">
                                  查看统计
                                </div>
                              </td>

                              <!--                            <td style="text-align: center">
                                                            <el-button
                                                                size="mini"
                                                                @click="handleEditScore(item)" style="margin-left: 8px;">修改佣金
                                                            </el-button>
                                                            <el-button
                                                                size="mini"
                                                                type="primary"
                                                                @click="checkUserScore(item)" style="margin-top: 5px;">佣金记录
                                                            </el-button>
                                                            <el-button
                                                                size="mini"
                                                                @click="handleEdit(item)" style="margin-top: 5px;">修改积分
                                                            </el-button>
                                                            <el-button
                                                                size="mini"
                                                                type="primary"
                                                                @click="checkScore(item)" style="margin-top: 5px;">积分记录
                                                            </el-button>
                                                            <el-button
                                                                size="mini"
                                                                type="success"
                                                                @click="editLevel(item)" style="margin-top: 5px;">修改等级
                                                            </el-button>
                              &lt;!&ndash;                              <el-button
                                                                size="mini"
                                                                type="warning"
                                                                @click="openWxUserList(item)" style="margin-top: 5px;">查看粉丝
                                                            </el-button>&ndash;&gt;
                                                            <el-button
                                                                size="mini"
                                                                type="warning"
                                                                @click="editAgent(item)" style="margin-top: 5px;">修改代理
                                                            </el-button>
                                                          </td>-->
                            </tr>
                            </tbody>
                          </table>
                          <Pagination
                              ref="Pagination"
                              :total-items="totalCount"
                              @page-change="pageChange"
                          ></Pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
          id="kt_content_container"
          class="container"
          style="
        margin-top: 10px;
        max-width: 65%;
        flex-direction: row !important;
        display: flex;
      "
      >
        <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
          <div class="d-flex flex-column flex-column-fluid">
            <div id="kt_app_content" class="" style="margin-bottom: 10px">
              <!-- {{idArr}} {{ sumMoney }} -->
              <div class="card card-flush" style="position: relative">
                <div class="card-body">
                  <div id="myTabContent" class="tab-content">
                    <div
                        v-loading="loading"
                        class="card mb-5 mb-xl-8"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        element-loading-spinner="el-icon-loading"
                        element-loading-text="拼命加载中"
                        style="margin-left: 3px; width: 100%"
                    >
                      <div style="height: calc(100vh - 50px)">
                        <div style="display: flex">
                          <div style="display: flex;">
                            <div style="background-color: #409EFF;width: 15px;height:15px;"></div>
                            <div style="margin-left: 10px;">点击可显示下级会员</div>
                          </div>
                          <div style="display: flex;margin-left: 20px;">
                            <div style="background-color: #666666;width: 15px;height:15px;"></div>
                            <div style="margin-left: 10px;">已无下级会员</div>
                          </div>
                          <div style="margin-left: 70px;">请点击左侧用户，查看业绩统计数据</div>

                        </div>

                        <RelationGraph ref="graphRef" :on-line-click="onLineClick" :on-node-click="onNodeClick"
                                       :on-node-expand="onNodeExpand"
                                       :options="graphOptions"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import sd from "silly-datetime";
import RelationGraph from 'relation-graph';
import {
  exportUserExcel,
  getBindWxUserTelApi, getShopUserPageApi, getWxScoreApi,
  getWxUserCountApi,
  getWxUserPageApi,
  getWxUserScoreApi, updateScoreApi,
  updateUserLevelApi,
  updateUserScoreApi, updateUserAgentApi
} from "@/api/WxUserApi";
import {getStatisticsByuserId, getClickStatisticsByuserId} from "@/api/orderApi";


export default {
  name: "",
  components: {RelationGraph},
  // 组件的props定义,用于子组件接收父组件传值
  // 组件的data属性
  data() {
    return {
      graphOptions: {
        "backgroundImage": "https://ssl.relation-graph.com/images/relatioon-graph-canvas-bg.png",
        "backgroundImageNoRepeat": true,
        "defaultNodeBorderWidth": 0,
        "defaultLineShape": 4,
        "defaultNodeShape": 1,
        "defaultNodeWidth": 150,
        "defaultNodeHeight": 120,
        "defaultJunctionPoint": "tb",
        "layouts": [
          {
            "label": "中心",
            "layoutName": "tree",
            "centerOffset_x": 0,
            "centerOffset_y": 0,
            "distance_coefficient": 1,
            "layoutDirection": "v",
            "from": "top",
            "levelDistance": "",
            "min_per_width": "200",
            "max_per_width": 500,
            "min_per_height": "300",
            "max_per_height": 500
          }
        ]
      },
      params: {
        current: 1,
        size: 10,
        tel: "",
        name: "",
        cardId: "",
        cardPassword: "",
        status: "",
        level: "",
        userId: "",
        pUserId: "",
        agent: "",

      },
      list: [],
      loading: false,
      dialogVisible: false,
      totalCount: 0,

      wxShopScoreVisible: false,
      wxUserScoreTableData: [],
      wxUserScoreParams: {
        current: 1,
        size: 10,
        userId: ""
      },
      wxShopUserScoreTotal: 0,
      wxShopUserScoreVisible: false,

      editLevelVisible: false,
      level: "",
      levelUserId: "",


      wxShopUserVisible: false,
      wxUserParams: {
        current: 1,
        size: 10,
        pUserId: '',
      },
      tableData: [],
      tableDataTotal: 0,

      wxShopUserVisibleTwo: false,
      wxUserParamsTwo: {
        current: 1,
        size: 10,
        pUserId: '',
      },
      tableDataTwo: [],
      tableDataTotalTwo: 0,


      editAgentVisible: false,
      agent: "",
      agentUserId: "",
      statisticsParams: {
        userId: '',
      },
      clickStatisticsParams: {
        userId: '',
      },
      jsonData: '',


    };
  },
  // 组件的方法
  methods: {

    gotoStatistics(row) {
      this.statisticsParams.userId = row.id
      this.showGraph()

    },

    async showGraph() {

      let {data} = await getStatisticsByuserId(this.statisticsParams)
      this.jsonData = data

      // 以上数据中的node和link可以参考"Node节点"和"Link关系"中的参数进行配置
      this.$refs.graphRef.setJsonData(this.jsonData, (graphInstance) => {
        // Called when the relation-graph is completed
      })
    },

    async onNodeClick(nodeObject, $event) {

      let color = nodeObject.color
      if (color == '#666666') {
        this.$swal.fire({
          icon: "warning",
          title: "已无下级会员！",
          toast: true,
          position: "center",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      } else {
        this.clickStatisticsParams.userId = nodeObject.id

        let {data} = await getClickStatisticsByuserId(this.clickStatisticsParams)

        this.jsonData.nodes.push(...data.nodes)
        this.jsonData.lines.push(...data.lines)

        this.$refs.graphRef.setJsonData(this.jsonData, (graphInstance) => {
          // Called when the relation-graph is completed
        })
      }



    },

    onLineClick(lineObject, $event) {
      console.log('onLineClick:', lineObject)
    },

    toggleDropdown(index) {
      this.$nextTick(() => {
        const dropdown = document.getElementById(`dropdown-${index}`);
        new KTMenu(dropdown);
      });
    },

    openWxUserList(row) {
      this.getWxShopUserList(row)
      this.wxShopUserVisible = true
    },

    async getWxShopUserList(row) {
      this.wxUserParams.pUserId = row.id
      // let {data} = await getShopUserPageApi(this.wxUserParams)
      let {data} = await getWxUserPageApi(this.wxUserParams)
      this.tableData = data.rows
      this.tableDataTotal = data.total
    },

    handleSizeChange(val) {
      this.wxUserParams.size = val
      this.getWxShopUserList()
    },
    handleCurrentChange(val) {
      this.wxUserParams.current = val
      this.getWxShopUserList()
    },

    openWxUserListTwo(row) {
      this.getWxShopUserListTwo(row)
      this.wxShopUserVisibleTwo = true
    },

    async getWxShopUserListTwo(row) {
      this.wxUserParamsTwo.pUserId = row.id
      // let {data} = await getShopUserPageApi(this.wxUserParams)
      let {data} = await getWxUserPageApi(this.wxUserParamsTwo)
      this.tableDataTwo = data.rows
      this.tableDataTotalTwo = data.total
    },

    handleSizeChangeTwo(val) {
      this.wxUserParamsTwo.size = val
      this.getWxShopUserListTwo()
    },
    handleCurrentChangeTwo(val) {
      this.wxUserParamsTwo.current = val
      this.getWxShopUserListTwo()
    },

    pageChange(currentPage, pageSize) {
      this.params.current = currentPage;
      this.params.size = pageSize;
      this.getList();
    },
    async getList() {
      this.loading = true
      let {data} = await getWxUserPageApi(this.params)
      this.list = data.rows
      this.loading = false
      this.totalCount = data.total
    },
    resetBtn() {
      this.params = {
        current: 1,
        size: 10,
        tel: "",
        name: "",
        cardId: "",
        cardPassword: "",
        status: "",
        level: "",
        userId: "",
        pUserId: "",
        agent: "",

      };
      this.getList();
    },

    handleEditScore(row) {
      this.$prompt('请输入要修改的佣金', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]\d*(\.\d+)?$/,
        inputErrorMessage: '佣金格式不正确',
        inputValue: row.userScore
      }).then(({value}) => {
        this.updateScore(row.id, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },

    async updateScore(userId, score) {
      await updateScoreApi({userId, score})
      this.$message.success("修改成功")
      this.getList()
    },

    checkUserScore(row) {
      this.wxShopScoreVisible = true
      this.wxUserScoreTableData = []
      this.wxUserScoreParams.current = 1
      this.wxUserScoreParams.size = 10
      this.wxUserScoreParams.userId = row.id
      this.getWxScore();
    },

    async getWxScore() {
      let {data} = await getWxScoreApi(this.wxUserScoreParams)
      this.wxUserScoreTableData = data.rows
      this.wxShopUserScoreTotal = data.total
    },

    handleEdit(row) {
      this.$prompt('请输入要修改的积分', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]\d*(\.\d+)?$/,
        inputErrorMessage: '积分格式不正确',
        inputValue: row.score
      }).then(({value}) => {
        this.updateUserScore(row.id, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },

    async updateUserScore(userId, score) {
      await updateUserScoreApi({userId, score})
      this.$message.success("修改成功")
      this.getList()
    },

    checkScore(row) {
      this.wxUserScoreTableData = []
      this.wxUserScoreParams.current = 1
      this.wxUserScoreParams.size = 10
      this.wxUserScoreParams.userId = row.id
      this.getWxUserScore();
      this.wxShopUserScoreVisible = true
    },

    async getWxUserScore() {
      let {data} = await getWxUserScoreApi(this.wxUserScoreParams)
      this.wxUserScoreTableData = data.rows
      this.wxShopUserScoreTotal = data.total
    },
    editLevel(row) {
      this.level = row.level
      this.levelUserId = row.id
      this.editLevelVisible = true
    },
    async updateLevel() {
      await updateUserLevelApi({userId: this.levelUserId, level: this.level})
      this.$message.success("修改成功")
      this.editLevelVisible = false
      this.getList()
    },

    editAgent(row) {
      this.agent = row.agent
      this.agentUserId = row.id
      this.editAgentVisible = true
    },
    async updateAgent() {
      await updateUserAgentApi({userId: this.agentUserId, agent: this.agent})
      this.$message.success("修改成功")
      this.editAgentVisible = false
      this.getList()
    },

  },
  // 在created钩子中执行的操作
  created() {
    this.getList();

  },
  mounted() {
    // this.showGraph();

  },

  updated() {
    // 当数据更新后，可以在此处手动初始化下拉菜单插件
    this.rows.forEach((_, index) => {
      this.toggleDropdown(index);
    });
  },
  filters: {
    dataFormat(date) {
      return sd.format(date, "YYYY-MM-DD HH:mm:ss");
    },
    format(num) {
      return (
          Number(num)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,") + " 元"
      );
    },
  },
};
</script>

<!-- 组件的样式 -->
<style scoped>
.el-range-separator {
  padding: 0;
}
</style>
